<!--
  File name: RadioButton.vue
  Program Description:
    -  This component customizes the existing radio group component from vuetify
    to allow the radio buttons be grouped accordingly.

-->

<template>
  <v-container fluid>
    <v-radio-group
      :id="id"
      v-model="selectedText"
      class="pt-0 mt-0"
      :error-messages="errorMessages"
      :label="label"
      :row="isRow"
      :dense="isDense"
      :style="cssStyle"
      :class="fieldClass"
      :hide-details="hideDetails"
    >
      <v-radio
        v-for="option in options"
        :key="option[itemValue] || option"
        :label="option[itemText] || option"
        :value="option[itemValue] || option"
        :disabled="!canEdit"
      />
    </v-radio-group>
  </v-container>
</template>

<script>
/* eslint-disable vue/prop-name-casing */
export default {
  model: {
    prop: 'val',
    event: 'input'
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    'item-text': {
      type: String,
      default: 'name'
    },
    'item-value': {
      type: String,
      default: '_id'
    },
    options: {
      type: Array,
      default: undefined
    },
    'error-messages': {
      type: Array,
      default: undefined
    },
    'field-class': {
      type: String,
      default: undefined
    },
    isRow: Boolean,
    canEdit: {
      type: Boolean,
      default: true
    },
    hideDetails: {
      type: [Boolean, String],
      default: false
    },
    label: {
      type: String,
      default: undefined
    },
    value: {
      type: String,
      default: undefined
    },
    isDense: {
      type: Boolean,
      default: false
    },
    cssStyle: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    selectedText: ''
  }),
  watch: {
    selectedText (val) {
      this.$emit('input', val)
    },
    '$props.value' () {
      this.selectedText = this.$props.value
    }
  },
  created () {
    if (this.$props.value) {
      this.selectedText = this.$props.value
    }
  }
}
</script>
